export const ADMIN_PRODUCT_ENDPOINTS = {
  editExpiration: "/admin/ajax/edit-product-expiration",
  editSalesBonus: "/admin/ajax/edit-product-sales-bonus",
  searchProduct: "/admin/ajax/search-product",
  searchProductLineItems: "/admin/ajax/search-product-line-items",
  fulfillableVariants: "/admin/ajax/get-product-fulfillable-variants",
  featuredProducts: "/admin/ajax/featured-products",
  tags: "/admin/ajax/tags",
  addTag: "/admin/ajax/add-tag",
  removeTag: "/admin/ajax/remove-product-tag",
  toggleFeatured: "/admin/ajax/toggle-product-featured",
  cacheMockups: "/admin/ajax/cache-mockups",
  updateSearchIndex: "/admin/ajax/update-search-index",
  emailCardProduct: "/admin/ajax/email-card-product",
  analytics: (productId) => `/admin/ajax/product-analytics/${productId}`,
  orders: (productId) => `/admin/ajax/product-orders/${productId}`,

  // The Edit Product page (admin/edit-product.vue and admin/components/edit-product/*).
  get: "/admin/ajax/get-product",
  edit: "/admin/ajax/edit-product",
  variants: (productId) => `/admin/ajax/get-product-variants/${productId}`,
  uploadImage: "/admin/ajax/upload-image",
  deleteImage: "/admin/ajax/delete-image",
  changeImageLabel: "/admin/ajax/change-label",
  changeImagePosition: "/admin/ajax/change-position",
  updateSecondArtwork: "/admin/ajax/update-second-artwork",
  uploadSecondArtwork: "/admin/ajax/upload-second-artwork",
  deleteSecondArtwork: "/admin/ajax/delete-second-artwork",
  backPrintPricingPreview: (productId) => `/admin/ajax/preview-back-print-pricing/${productId}`,
  migrate: "/admin/ajax/migrate-product",
  // The page's action buttons (each posts product[id], see runProductAction).
  accept: "/admin/ajax/accept-product",
  reject: "/admin/ajax/reject-product",
  unreject: "/admin/ajax/unreject-product",
  clone: "/admin/ajax/clone-product",
  replaceOnDemand: "/admin/ajax/replace-on-demand-product",
  replaceStock: "/admin/ajax/replace-stock-product",
  launch: "/admin/ajax/launch-product",
  standby: "/admin/ajax/standby-product",
  unstandby: "/admin/ajax/unstandby-product",
  retire: "/admin/ajax/retire-product",
  generateMockupArchive: "/admin/ajax/generate-mockup-archive",
};
